import React, { FC } from 'react'
import { Button } from 'shared/components'
import classes from './Cooperation.module.scss'
import { NavLink } from 'react-router-dom'

type Props = {
  page: 'home' | 'about'
}

export const Cooperation: FC<Props> = (): JSX.Element => {
  return (
    <div className={classes.container}>
      <div className="container">
        <h2 className="reveal-from-bottom-large" data-reveal-delay={30}>
          Хотите с нами
          <br /> сотрудничать?
        </h2>
        <div className="row reveal-from-bottom-large" data-reveal-delay={30}>
          <div
            className="col-xs-12 col-sm-6 reveal-from-bottom-small"
            data-reveal-delay={30}
          >
            <div className={`${classes.item} ${classes.item_prod}`}>
              <div className={classes.item_title}>производство</div>
              <div className={classes.item_descr}>
                Мы работаем с лучшими представителями индустрии и постоянно
                расширяем круг наших партнеров.
              </div>
              <div>
                <NavLink to="/production">
                  <Button size="medium">Познакомиться</Button>
                </NavLink>
              </div>
            </div>
          </div>
          <div
            className="col-xs-12 col-sm-6 reveal-from-bottom-small"
            data-reveal-delay={30}
          >
            <div className={`${classes.item} ${classes.item_dist}`}>
              <div className={classes.item_title}>Дистрибуция</div>
              <div className={classes.item_descr}>
                Привлекаем клиентов используя собственные ресурсы доставки
                контента, а также через широкую сеть внешних партнерств как в
                цифровом, так и оффлайн форматах.
              </div>
              <div>
                <NavLink to="/distribution">
                  <Button size="medium">Узнать больше</Button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
